import { Fragment, type ReactNode } from 'react';

export interface TopBarProps {
  breadcrumbs?: string[];
  title: string;
  lead?: string;
  actions?: ReactNode;
}

export function TopBar({ breadcrumbs = [], title, lead, actions }: TopBarProps) {
  return (
    <header
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 14,
        padding: '32px 40px 28px',
        borderBottom: '1px solid var(--gc-line)',
        background: 'var(--gc-cream)',
      }}
    >
      {breadcrumbs.length > 0 ? (
        <nav
          aria-label="Breadcrumb"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontFamily: 'var(--font-sans)',
            fontWeight: 600,
            fontSize: 10,
            letterSpacing: 'var(--track-xwide)',
            textTransform: 'uppercase',
            color: 'var(--gc-stone)',
          }}
        >
          {breadcrumbs.map((crumb, i) => (
            <Fragment key={`${i}-${crumb}`}>
              {i > 0 ? <span style={{ color: 'var(--gc-mist)' }}>/</span> : null}
              <span
                style={{
                  color: i === breadcrumbs.length - 1 ? 'var(--gc-green-dark)' : 'var(--gc-stone)',
                }}
              >
                {crumb}
              </span>
            </Fragment>
          ))}
        </nav>
      ) : null}

      <div
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          gap: 32,
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 720 }}>
          <h1
            style={{
              margin: 0,
              fontFamily: 'var(--font-sans)',
              fontWeight: 300,
              fontSize: 40,
              color: 'var(--fg)',
              letterSpacing: 'var(--track-tight)',
              lineHeight: 1.05,
            }}
          >
            {title}
          </h1>
          {lead ? (
            <p
              style={{
                margin: 0,
                fontFamily: 'var(--font-serif)',
                fontStyle: 'italic',
                fontWeight: 400,
                fontSize: 20,
                color: 'var(--gc-charcoal)',
                lineHeight: 1.4,
              }}
            >
              {lead}
            </p>
          ) : null}
        </div>
        {actions ? <div style={{ display: 'flex', gap: 10, flexShrink: 0 }}>{actions}</div> : null}
      </div>
    </header>
  );
}
